import * as constActions from './FileMonitoringConstsActions';
import initialState from './FileMonitoringInitiateState';

export default function fileMonitoringReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.INIT_FILE_MONITORING_DATA: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.GET_FILE_MONITORING_COLUMNS: {
      return Object.assign({}, state, {
        columns: action.data
      });
    }
    case constActions.GET_FILE_MONITORING_HEADER_TO_DISPLAY: {
      return Object.assign({}, state, {
        headerColumns: action.data
      });
    }
    case constActions.FETCH_RESULTS: {
      return Object.assign({}, state, {
        results: action.data
      });
    }
    case constActions.FM_SAVE_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.param
      });
    }
    case constActions.FETCH_EXISTING_RESULTS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.data]
      });
    }
    default:
      return state;
  }
}
